module.exports = __webpack_public_path__ + "141ef3ed430078021ff59541b3697acd.svg";